import { IconAi2Logo } from '@/components/icons/IconAi2Logo';

import { Avatar, Box, Theme } from '@mui/material';
import styled from 'styled-components';

enum DVSpeaker {
  FINISH_REASON = 'finish-reason',
  PLANNER = 'planner',
  PROGRAMMER = 'programmer',
  USER = 'user',
}

type SpeakerProps = {
  speakerId: DVSpeaker;
  children: React.ReactNode;
};
export const Speaker = ({ speakerId, children }: SpeakerProps) => {
  return (
    <SpeakerWrapper>
      <SpeakerIcon variant="rounded" $speaker={speakerId}>
        {<IconAi2Logo />}
      </SpeakerIcon>
      {children}
    </SpeakerWrapper>
  );
};

const SpeakerWrapper = styled(Box)`
  align-items: flex-start;
  color: ${({ theme }) => theme.color['cream-100'].hex};
  display: flex;
  font-weight: 700;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const SpeakerIcon = styled(Avatar)<{ $speaker: DVSpeaker }>(
  ({ theme, $speaker }) => `
  height: 30px;
  width: 30px;

   &.MuiAvatar-root {
    background-color: ${getSpeakerBackgroundColor(theme, $speaker)};
  }

  svg {
    fill: ${theme.color['extra-dark-teal-10'].hex};
  }
`,
);

function getSpeakerBackgroundColor(theme: Theme, speakerId: DVSpeaker): string {
  switch (speakerId) {
    case DVSpeaker.FINISH_REASON:
      return theme.color['success-green-100'].hex;
    case DVSpeaker.PLANNER:
      return theme.color['pink-100'].hex;
    case DVSpeaker.PROGRAMMER:
      return theme.color['green-100'].hex;
    case DVSpeaker.USER:
      return theme.color['purple-100'].hex;
    default:
      return theme.color['warning-orange-100'].hex;
  }
}
